import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IOptionType } from 'interfaces/forms';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.OVERVIEW}.${BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.FUNDING_NEEDS}` as const;

export const FUNDING_NEEDS_NAMES = {
  FUNDING_DIRECTIONS: 'fundingDirections',
} as const;

export interface IFundingNeedsOverviewForm {
  [FUNDING_NEEDS_NAMES.FUNDING_DIRECTIONS]: IOptionType[];
}

export const overviewFundingNeedsInitialValues: IFundingNeedsOverviewForm = {
  [FUNDING_NEEDS_NAMES.FUNDING_DIRECTIONS]: [],
};
